<template>
    <!-- 按钮样式文件上传 -->
    <div>
        <el-upload
            class="upload"
            :action="uploadUrl"
            :before-upload="handleBeforeUpload"
            :file-list="fileList"
            :limit="limit"
            :on-exceed="handleExceed"
            :headers="headers"
            :http-request="upload"
            v-bind="$attrs"
            with-credentials
            :on-remove="handleRemove">
            <div style="position: relative">
                <el-button :size="btnSize" type="primary" :style="{ background: btnbg }" plain>{{ buttonTxt }}</el-button>
            </div>
        </el-upload>
        <el-progress :stroke-width="2" v-if="uploadIng && needress" :percentage="percentage"></el-progress>
    </div>
</template>

<script>
import axios from 'axios';
import { blockUploadSuccess, getFileUUID } from '@/api/request';
import { getToken } from '@/plugins/auth';
export default {
    props: {
        linkfileList: {
            type: Array,
            default: () => []
        },
        limit: {
            type: Number,
            default: 5
        },
        fileType: {
            type: String,
            default: ''
        },
        btnSize: {
            type: String,
            default: ''
        },
        btnbg: {
            type: String,
            default: '#EDF0FF'
        },
        buttonTxt: {
            type: String,
            default: '点击上传'
        },
        index: {
            type: String | Number,
            default: ''
        },
        indexs: {
            type: String | Number,
            default: ''
        },
        //区分全局字段的文件上传还是样本字段上传
        isGlobal: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            type: this.fileType,
            uploadUrl: process.env.VUE_APP_BASE_API + '/file/blockUpload',
            uploadUrl1: process.env.VUE_APP_BASE_API + '/file/upload',
            headers: {
                Authorization: 'Bearer ' + getToken()
            },
            fileList: [],
            uploadIng: false,
            internalDisabled: false,
            needress: true,
            uuid: undefined,
            percentage: 0
            // fileType: "DOC,DOCX,XLS,XLSX,PPT,PDF,TXT,JPG,JPEG,PNG,BMP,GIF"
        };
    },
    watch: {
        linkfileList: {
            immediate: true,
            handler() {
                this.fileList = this.linkfileList;
            }
        },
        fileType: {
            handler(newValue, oldValue) {
                this.type = newValue;
            },
            deep: true
        }
    },
    created() {
        this.getFileId();
    },
    methods: {
        async getFileId() {
            const res = await getFileUUID()
            this.uuid = res.data
        },
        //TODO  可以将分块大小放到组件中设置
        async upload(options) {
            this.uploadIng = true;
            this.internalDisabled = true;
            this.uploadIng = true;
            let file = options.file;
            const chunkSize = 0.8 * 1024 * 1024; // 每个块的大小为 10MB
            // let size = file.size;
            // if (size <= 10 * 1024 * 1024) {
            //     chunkSize = 0.8 * 1024 * 1024;
            // } else if (size <= 50 * 1024 * 1024) {
            //     chunkSize = 5 * 1024 * 1024;
            // } else {
            //     chunkSize = 10 * 1024 * 1024;
            // }
            const chunks = [];
            let startPos = 0;
            let percentage = 0;
            while (startPos < file.size) {
                chunks.push(file.slice(startPos, startPos + chunkSize));
                startPos += chunkSize;
            }
            let uploadStatus = [];
            chunks.map((chunk, index) => {
                const data = new FormData();
                data.set('dirName', this.uuid);
                data.set('fileName', file.name);
                data.set('size', file.size);
                data.set('chunks', chunks.length);
                data.set('chunk', index + 1);
                data.append('file', chunk);
                axios
                    .post(this.uploadUrl, data, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            Authorization: 'Bearer ' + getToken()
                        }
                    })
                    .then((res) => {
                        if (res.data.code === 200) {
                            percentage++;
                            uploadStatus.push('true');
                        } else {
                            uploadStatus.push('false');
                        }
                        this.updatePercentage(percentage, chunks.length, file.size, file.name, uploadStatus);
                    })
                    .catch((err) => {
                        console.log(err, 'err');
                        uploadStatus.push(false);
                        this.updatePercentage(percentage, chunks.length, file.size, file.name, uploadStatus);
                    });
            });
            this.$emit('success', this.fileList);
            this.$refs.uploadFile.elForm.clearValidate();
        },
        getUploadUrl(size, name) {
            blockUploadSuccess({ dirName: this.uuid, size: size })
                .then((res) => {
                    // let fileInfo = res.data;
                    let fileInfo = {
                        url: res.data,
                        name: name
                    };
                    this.fileList.push(fileInfo);
                    this.handleUploadSuccess(res, fileInfo, this.fileList);
                })
                .catch((err) => {
                    console.log(err);
                    this.uploadIng = false;
                    this.internalDisabled = false;
                    this.percentage = 0;
                    this.filedList.pop();
                    this.$message.error('文件上传失败');
                });
        },
        updatePercentage(num, total, size, name, list) {
            if (list.length === total) {
                if (list.includes('false')) {
                    this.uploadIng = false;
                    this.internalDisabled = false;
                    this.percentage = 0;
                    this.filedList.pop();
                    this.$message.error('文件上传失败');
                } else {
                    this.getUploadUrl(size, name);
                }
            }
            this.percentage = Math.floor((num / total) * 100);
            // if (num === total) {

            // }
        },
        // 上传前校检格式和大小
        handleBeforeUpload(file) {
            // 校检文件类型
            if (this.type) {
                let typeList = this.type.split(',');
                return this.beforeUpload(file, typeList, this.type);
            }
            if (file.name.length > 50) {
                this.$message.error('文件名长度不能超过50个字');
                return false;
            }
            return true;
        },
        // 文件个数超出
        handleExceed(files, fileList) {
            this.$message.warning(`当前限制只能上传 ${this.limit} 个文件`);
        },
        getFile(type, index, refIdx) {
            this.$emit('getFile', this.fileList, type, index, refIdx);
        },
        // 上传失败
        handleUploadError(err) {
            this.$message.error('上传失败, 请重试');
        },
        // 上传成功回调
        handleUploadSuccess(res, file, fileList) {
            this.$message.success('上传成功');
            this.uploadIng = false;
            this.internalDisabled = false;
            this.percentage = 0;
            this.fileList = fileList.map((i) => {
                return { name: i.name, url: i.response ? i.response.data.url : i.url };
            });
            //只有存在index才会手动更新外部文件列表（index 是下单时才有）
            if (this.index || this.index === 0) {
                let index = this.index;
                let indexs = this.indexs;
                if (this.isGlobal === true) {
                    index = 0;
                    indexs = this.index;
                }
                this.$emit('getFileOrder', this.fileList, index, indexs, this.isGlobal);
            }
            // this.fileList.push({ name: res.data.name, url: res.data.url });
            this.$emit('clearValidate');
        },
        handleRemove(file, fileList) {
            this.fileList = this.fileList.filter((item) => item.uid !== file.uid);
        }
    }
};
</script>
